module.exports = __webpack_public_path__ + "static/media/ic_proyectos_borders_pin.f5f24624.svg";